import * as React from "react";
import { Table, Button, Pane, BanCircleIcon } from "evergreen-ui";
import { useAPI } from "../../Api";
const ActionIcons = {
    FOLD: "Fold",
    CUT: "Cut",
    IGNORE: React.createElement(BanCircleIcon, null),
};
function Action(props) {
    let actions = props.actions || ["CUT", "FOLD", "IGNORE"];
    const [options] = React.useState(actions);
    let selected = actions.indexOf(props.value) < 0 ? actions[0] : props.value;
    return (React.createElement(Pane, { onChange: (v) => {
            props.onChange(v);
        } }, options
        .filter((v) => v != "IGNORE")
        .map((v) => (React.createElement(Button, { key: v, size: "small", title: v, appearance: v == selected ? "primary" : null, onClick: () => {
            props.onChange(v);
        } }, ActionIcons[v])))));
}
export function Part(props) {
    let { isAdmin } = useAPI();
    return (React.createElement(Table.Row, { isSelected: props.isSelected, isSelectable: true, height: "32", onSelect: () => {
            props.selectIds(props.ids);
        }, onMouseOver: () => {
            props.selectIds(props.ids);
        } },
        React.createElement(Table.TextCell, null, props.Type),
        React.createElement(Table.TextCell, null,
            React.createElement(Action, { actions: props.actions || ["CUT", "IGNORE"], value: props.Action, onChange: props.onChange })),
        isAdmin && (React.createElement(Table.TextCell, null,
            " ",
            React.createElement(Pane, { border: "1px solid red", borderRadius: "10px", height: "fit-content", textAlign: "center" },
                props.Length.toFixed(2),
                " mm")))));
}
function Line(props) {
    return (React.createElement(Table.Row, { isSelectable: true, height: "32", onSelect: () => {
            props.selectIds(props.ids);
        }, onMouseOver: () => {
            props.selectIds(props.ids);
        } },
        React.createElement(Table.TextCell, null,
            props.Type,
            " "),
        React.createElement(Table.TextCell, null,
            React.createElement(Action, { value: props.Action, onChange: props.onChange })),
        React.createElement(Table.TextCell, null, props.Qty),
        React.createElement(Table.TextCell, null, props.Length)));
}
export function Lines(props) {
    let lines = props.Lines;
    return lines.map((c, i) => {
        return (React.createElement(Line, { key: c.id, ids: c.ids, selectIds: props.selectIds, Type: "Line", Action: c.Type, Qty: c.count, Length: c.len, onChange: (e) => {
                c.Type = e;
                lines[i] = c;
                props.updateLine(lines);
            } }));
    });
}
